import { IChip } from "../types";

export class Operator implements IChip {
  keyword: string;
  readonly: boolean;

  constructor(operator: string = "AND", isReadonly: boolean = false) {
    this.keyword = operator;
    this.readonly = isReadonly;
  }

  toString() {
    return this.keyword;
  }
}
